export default __webpack_public_path__ + "static/pro@2x-67951d7cbd0e0b24d9abb48ed0839756.png";